import React, { useRef } from 'react';
import styled from 'styled-components';
import { rgba, darken } from 'polished';
import { compactPriceFormatter } from '../../../helpers/formatters';
import COLORS from '../../../constants/COLORS';
import usePriceItem from '../../../hooks/usePriceItem';
import { getBoundingClientRect } from '../../../helpers/coordinates';

const PriceItem = ({ price, mouseEnterHandler, mouseLeaveHandler }) => {
  const { isSelected, togglePrice } = usePriceItem({ price });

  const priceItemRef = useRef<HTMLLIElement>();

  const onMouseEnter = () => {
    if (priceItemRef.current) {
      const { left, width } = getBoundingClientRect(priceItemRef.current);

      mouseEnterHandler({
        content: price.tooltip,
        left: left + width / 2,
      });
    }
  };

  return (
    <Wrapper
      onClick={togglePrice}
      onMouseEnter={onMouseEnter}
      onMouseLeave={mouseLeaveHandler}
      ref={priceItemRef}
    >
      <PriceWrapper bg={price.color} isSelected={isSelected}>
        <PriceColor bg={price.color} isSelected={isSelected} />
        <StyledPrice isSelected={isSelected}>{`${compactPriceFormatter(
          price.value,
        )}+`}</StyledPrice>
      </PriceWrapper>
    </Wrapper>
  );
};

export default PriceItem;

const Wrapper = styled.li<any>`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  font-size: 12px;
  margin-left: 16px;

  @media screen and (max-width: 700px) {
    margin-left: 8px;
  }
`;

const PriceWrapper = styled.div<any>`
  position: relative;
  cursor: pointer;
  padding: 8px 12px 8px 28px;
  background: #ffffff;

  border: ${(prps) =>
    prps.isSelected
      ? `1px solid ${rgba(darken(0.2, prps.bg), 0.1)}`
      : '1px solid rgba(21, 16, 53, 0.1)'};

  border-radius: 8px;
`;

const PriceColor = styled.div<{ isSelected: boolean; bg: string }>`
  position: absolute;
  left: 0px;
  top: 50%;
  transform: ${(prps) => (prps.isSelected ? 'translate(0, -50%)' : 'translate(12px, -50%)')};
  background: ${(props) => props.bg};
  transition: all 0.1s linear;
  z-index: 0;
  border-radius: ${(prps) => (prps.isSelected ? '8px' : '50%')};
  width: ${(prps) => (prps.isSelected ? '100%' : '8px')};
  height: ${(prps) => (prps.isSelected ? '100%' : '8px')};
  &:after {
    content: '';
    position: absolute;
    left: 12px;
    top: 50%;
    width: 8px;
    height: 8px;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    opacity: ${(prps) => (prps.isSelected ? 1 : 0)};
  }
`;

const StyledPrice = styled.div<{ isSelected: boolean }>`
  position: relative;
  z-index: 1;
  transition: color 0.1s linear;
  line-height: 16px;
  color: ${(prps) => (prps.isSelected ? 'white' : COLORS.MARKETPLACE_BLACK)};
  font-weight: bold;
  font-size: 14px;
`;
